import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EDistinct,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
  EUnion,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutHeroSubscribeLeft = {
  factory: EElement({
    id: '6c30f42a-cd26-61f6-3ad8-562fc050f0b7',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('04c23a3f-30a0-98eb-6edc-d20581551b11')]),
      children: EList([
        EElement({
          id: '6c30f42a-cd26-61f6-3ad8-562fc050f0b8',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '63953fe1-a940-bcb9-2c9b-7639bda912b3',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('37a0db36-0c36-057c-7224-b52f6d799831'),
                  ]),
                  children: EList([
                    EElement({
                      id: '63953fe1-a940-bcb9-2c9b-7639bda912b4',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('199eff86-56aa-771a-7b1b-0b18fb1f60fa'),
                        ]),
                        children: EList([
                          EElement({
                            id: '63953fe1-a940-bcb9-2c9b-7639bda912b7',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h1'),
                              children: EList([
                                EElement({
                                  id: '63953fe1-a940-bcb9-2c9b-7639bda912b8',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Title copy goes here'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '63953fe1-a940-bcb9-2c9b-7639bda912b9',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('1b2031fc-27bc-6bb0-9580-913bd9335308'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '63953fe1-a940-bcb9-2c9b-7639bda912ba',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem. Etiam sodales ac felis id interdum.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '0c46ad33-e748-069c-d9a6-e0096a3a7a4c',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormWrapper')
                            ),
                            data: ERecord({
                              form: ERecord({
                                type: EText('wrapper'),
                              }),
                              styleBlockIds: EList([
                                EText('f934a89f-0f89-819e-c419-4b5922bf8760'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '0c46ad33-e748-069c-d9a6-e0096a3a7a4d',
                                  type: qualify(
                                    Plugins.name('Form'),
                                    Component.name('FormForm')
                                  ),
                                  data: ERecord({
                                    form: ERecord({
                                      type: EText('form'),
                                      name: EText('Hero Form'),
                                    }),
                                    Source: EUnion({
                                      tag: 'Default form',
                                      value: ERecord({}),
                                    }),
                                    attr: ERecord({
                                      id: EText('wf-form-Hero-Form'),
                                      name: EText('wf-form-Hero-Form'),
                                      'data-name': EText('Hero Form'),
                                      redirect: EText(''),
                                      'data-redirect': EText(''),
                                      action: EText(''),
                                      method: EEnum('get'),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '7ad366c4-cb0c-bb07-fa1a-65d560129e54'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '0c46ad33-e748-069c-d9a6-e0096a3a7a53',
                                        type: qualify(
                                          Plugins.name('Form'),
                                          Component.name('FormTextInput')
                                        ),
                                        data: ERecord({
                                          form: ERecord({
                                            name: EText('Hero Email'),
                                            type: EText('input'),
                                            passwordPage: EBoolean(false),
                                          }),
                                          attr: ERecord({
                                            autofocus: EBoolean(false),
                                            maxlength: ENumber(256),
                                            name: EText('Hero-Email'),
                                            'data-name': EText('Hero Email'),
                                            placeholder:
                                              EText('Enter your email'),
                                            type: EEnum('email'),
                                            id: EText('Hero-Email'),
                                            disabled: EBoolean(false),
                                            required: EBoolean(true),
                                          }),
                                          xattr: EList([
                                            ERecord({
                                              name: EText('aria-label'),
                                              value: EText('Enter your email'),
                                            }),
                                          ]),
                                          styleBlockIds: EList([
                                            EText(
                                              'a9e8bb77-4e4c-bace-23b9-13c29df83d85'
                                            ),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '0c46ad33-e748-069c-d9a6-e0096a3a7a54',
                                        type: qualify(
                                          Plugins.name('Form'),
                                          Component.name('FormButton')
                                        ),
                                        data: ERecord({
                                          form: ERecord({
                                            type: EText('button'),
                                          }),
                                          attr: ERecord({
                                            type: EText('submit'),
                                            value: EText('Get Started'),
                                            'data-wait':
                                              EText('Please wait...'),
                                          }),
                                          eventIds: EList([]),
                                          styleBlockIds: EList([
                                            EText(
                                              '5811e2db-f107-fb36-bedc-ae019c696e30'
                                            ),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                    temp: ERecord({
                                      state: EEnum('normal'),
                                      'password-state': EEnum('normal'),
                                    }),
                                  }),
                                }),
                                EElement({
                                  id: '0c46ad33-e748-069c-d9a6-e0096a3a7a55',
                                  type: qualify(
                                    Plugins.name('Form'),
                                    Component.name('FormSuccessMessage')
                                  ),
                                  data: ERecord({
                                    form: ERecord({
                                      type: EText('msg-done'),
                                    }),
                                    children: EList([
                                      EElement({
                                        id: '0c46ad33-e748-069c-d9a6-e0096a3a7a56',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          children: EList([
                                            EElement({
                                              id: '0c46ad33-e748-069c-d9a6-e0096a3a7a57',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Thank you! Your submission has been received!'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '0c46ad33-e748-069c-d9a6-e0096a3a7a58',
                                  type: qualify(
                                    Plugins.name('Form'),
                                    Component.name('FormErrorMessage')
                                  ),
                                  data: ERecord({
                                    form: ERecord({
                                      type: EText('msg-fail'),
                                    }),
                                    children: EList([
                                      EElement({
                                        id: '0c46ad33-e748-069c-d9a6-e0096a3a7a59',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          children: EList([
                                            EElement({
                                              id: '0c46ad33-e748-069c-d9a6-e0096a3a7a5a',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Oops! Something went wrong while submitting the form.'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'c3c56741-9afe-97af-06b4-9abe404d0536',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              block: EText('inline'),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8829443b-f005-1554-a272-e89504531e07'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '825adce2-03ff-57e8-fb9d-10bf405b8aaf',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    children: EList([
                                      EElement({
                                        id: '825adce2-03ff-57e8-fb9d-10bf405b8ab0',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('or Sign-up with Google'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'f23f9c77-0f90-a269-ff51-71952fc19ef0',
                                  type: qualify(
                                    Plugins.name('Embed'),
                                    Component.name('HtmlEmbed')
                                  ),
                                  data: ERecord({
                                    embed: ERecord({
                                      type: EText('html'),
                                      meta: ERecord({
                                        html: EText(
                                          '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M11.13 8.5L6.87296 4.24291L5.87067 5.24379L9.129 8.5L5.87067 11.7555L6.87225 12.7571L11.13 8.5Z" fill="currentColor"/>\n</svg>'
                                        ),
                                        div: EBoolean(false),
                                        iframe: EBoolean(false),
                                        script: EBoolean(false),
                                        compilable: EBoolean(false),
                                      }),
                                    }),
                                    insideRTE: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                      ),
                                    ]),
                                    value: EText(
                                      '<svg width="17" height="17" viewbox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M11.13 8.5L6.87296 4.24291L5.87067 5.24379L9.129 8.5L5.87067 11.7555L6.87225 12.7571L11.13 8.5Z" fill="currentColor"/>\n</svg>'
                                    ),
                                    content: EDistinct({
                                      name: qualify(
                                        Plugins.name('Embed'),
                                        typeName('CodeProp')
                                      ),
                                      value: EText(''),
                                    }),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '63953fe1-a940-bcb9-2c9b-7639bda912bd',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('199eff86-56aa-771a-7b1b-0b18fb1f60fa'),
                        ]),
                        children: EList([
                          EElement({
                            id: '63953fe1-a940-bcb9-2c9b-7639bda912be',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageMountains),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272f687230d0a80678e6c22"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('ef341d27-cbbe-501e-0430-474259d4edc3'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '04c23a3f-30a0-98eb-6edc-d20581551b11',
      type: 'class',
      name: 'Hero Subscribe Left',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '37a0db36-0c36-057c-7224-b52f6d799831',
      type: 'class',
      name: 'Hero Wrapper',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        medium: {
          styleLess:
            'margin-bottom: -40px; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '199eff86-56aa-771a-7b1b-0b18fb1f60fa',
      type: 'class',
      name: 'Hero Split',
      comb: '',
      styleLess:
        'display: flex; max-width: 46%; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
      children: [],
      variants: {medium: {styleLess: 'max-width: 100%; margin-bottom: 40px;'}},
    },
    {
      _id: '1b2031fc-27bc-6bb0-9580-913bd9335308',
      type: 'class',
      name: 'Margin bottom 24px',
      comb: '',
      styleLess: 'margin-bottom: 24px;',
      children: [],
      variants: {},
    },
    {
      _id: 'f934a89f-0f89-819e-c419-4b5922bf8760',
      type: 'class',
      name: 'Hero Form',
      comb: '',
      styleLess: 'margin-bottom: 12px;',
      children: [],
      variants: {
        tiny: {styleLess: 'margin-bottom: 15px; align-self: stretch;'},
      },
    },
    {
      _id: '7ad366c4-cb0c-bb07-fa1a-65d560129e54',
      type: 'class',
      name: 'Hero Form Container',
      comb: '',
      styleLess:
        'display: flex; justify-content: flex-start; align-items: stretch;',
      children: [],
      variants: {
        tiny: {styleLess: 'flex-direction: column; align-items: flex-start;'},
      },
    },
    {
      _id: 'a9e8bb77-4e4c-bace-23b9-13c29df83d85',
      type: 'class',
      name: 'Hero Form Input',
      comb: '',
      styleLess:
        'width: 240px; height: auto; margin-right: 9px; margin-bottom: 0px; padding-top: 5px; padding-right: 16px; padding-bottom: 5px; padding-left: 16px; border-top-style: solid; border-top-width: 1px; border-top-color: hsla(209.99999999999994, 12.20%, 83.92%, 1.00); border-right-style: solid; border-right-width: 1px; border-right-color: hsla(209.99999999999994, 12.20%, 83.92%, 1.00); border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(209.99999999999994, 12.20%, 83.92%, 1.00); border-left-style: solid; border-left-width: 1px; border-left-color: hsla(209.99999999999994, 12.20%, 83.92%, 1.00); transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: #1a1b1f; font-size: 14px; line-height: 20px;',
      children: [],
      variants: {
        main_hover: {
          styleLess:
            'border-top-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-right-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-bottom-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-left-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00);',
        },
        main_focus: {
          styleLess:
            'border-top-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-right-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-bottom-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00); border-left-color: hsla(213.84615384615384, 16.60%, 53.92%, 1.00);',
        },
        main_placeholder: {styleLess: 'color: hsla(228, 8.77%, 11.18%, 0.80);'},
        tiny: {styleLess: 'width: 100%; height: 48px; margin-bottom: 10px;'},
      },
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
    {
      _id: '8829443b-f005-1554-a272-e89504531e07',
      type: 'class',
      name: 'Text Link Arrow',
      comb: '',
      styleLess:
        'display: flex; justify-content: flex-start; align-items: center; color: #1a1b1f; font-size: 14px; line-height: 20px; text-decoration: none;',
      children: [],
      variants: {},
    },
    {
      _id: '6cdfed94-50ee-a092-b160-1f9b110b78cb',
      type: 'class',
      name: 'Arrow Embed',
      comb: '',
      styleLess: 'display: flex; margin-left: 2px;',
      children: [],
      variants: {},
    },
    {
      _id: 'ef341d27-cbbe-501e-0430-474259d4edc3',
      type: 'class',
      name: 'Shadow Two',
      comb: '',
      styleLess:
        'box-shadow: 0 4px 24px 0 hsla(214.83870967741936, 17.32%, 64.90%, 0.08);',
      children: [],
      variants: {},
    },
  ],
} as const;
